import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommonConstants } from '../../../../common/constants/common-constants';
import { PlannedOutagesDetailResponse } from '../model/planned-outagesdetailresponse';

@Injectable()
export class PlannedOutageDetailService {

    constructor(public http: HttpClient) {
    }

    // function call to fetch item detail
        public getPlannedOutageDetail(plannedOutageId: number): Observable<PlannedOutagesDetailResponse> {
            return this.http.get<PlannedOutagesDetailResponse>(CommonConstants.SERVICE_VERSION_PATH_V1
                + '/customer/plannedoutages/' + plannedOutageId);
        }

}
